/**
 * Labstep
 */

import { Filter } from 'labstep-web/constants/filters';

export const filters = [
  Filter.group,
  Filter.log_created_by,
  Filter.date_range,
  Filter.log_object_class,
];
